






























































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { List } from 'linqts'
import moment from "moment";

// Servicios
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { toastService } from '@/services/ToastService';
import GenericService from '@/services/GenericService';
import { FiltroService } from '@/services/FiltroService';
import { DecimoService } from '@/services/DecimoService';
import { authService } from '@/services/AuthService';

// Componentes
import SorteoSacarNumeros from './SorteoSacarNumeros.vue';
import SorteoActualizarNumerosPopup from './SorteoActualizarNumerosPopup.vue';
import SorteoNumerosSacados from './SorteoNumerosSacados.vue';
import SorteoNumerosDisponibles from './SorteoNumerosDisponibles.vue';
import SorteoHistoricoTotales from './HistoricoTotales/SorteoHistoricoTotales.vue';
import SorteoNumerosTodos from './SorteoNumerosTodos.vue';
import DialogForm from "@/components/DialogForm.vue";
import DialogConfirm from "@/components/DialogConfirm.vue";

// Model
import { Sorteo } from '@/model/Sorteo';
import { Filtro } from '@/model/Filtro';
import { Response } from '@/model/Response';


@Component({
  components: {
    DialogForm,
    DialogConfirm,
    SorteoSacarNumeros,
    SorteoNumerosSacados,
    SorteoNumerosDisponibles,
    SorteoHistoricoTotales,
    SorteoNumerosTodos,
    SorteoActualizarNumerosPopup
  },
})
export default class SorteoDetail extends Vue {
  isAdmin: any;

  sorteoService: any | GenericService<Sorteo> = new GenericService<Sorteo>("Sorteo");
  sorteo: any | Sorteo = {};

  filtroService: any | FiltroService = new FiltroService();
  filtroSacarNumeros: any | Filtro = {};
  filtroNumerosDisponibles: any | Filtro = {};

  decimoService: any | DecimoService = new DecimoService();
  visibleActualizarNumeros: boolean = false;
  actualizandoNumeros: boolean = false;
  nameEventCloseActualizarNumeros: string = ""
  nameEventSaveActualizarNumeros: string = ""

  idSorteo: number = 0;

  mounted() {

  }

  created(){
    logService.Info("Inicio - Sorteo: "+this.$route.params.id,"SorteoDetail.vue - created()");
    this.idSorteo = parseInt(this.$route.params.id);
    this.isAdmin = authService.isAdmin();

    this.load();
    this.nameEventCloseActualizarNumeros = "ActualizarNumerosForm-Close-"+this.$route.params.id;
    this.nameEventSaveActualizarNumeros = "ActualizarNumerosForm-Save-"+this.$route.params.id;

    eventService.on(this.nameEventCloseActualizarNumeros, (obj: any) => {
      this.visibleActualizarNumeros = false;
    });

    eventService.on(this.nameEventSaveActualizarNumeros, (obj: any) => {
      this.visibleActualizarNumeros = false;
      logService.Info("Actualizando números disponibles - Sorteo: "+this.$route.params.id,"SorteoDetail.vue - created()");
      toastService.success("Actualizando números disponibles.");
      this.actualizandoNumeros = true;
      this.decimoService.import(this.sorteo.Id, obj)
      .then((res: Response) => {
        this.actualizandoNumeros = false;
        if(res.Message !== "" && res.Message !== null){
          logService.Info(res.Message+" - Sorteo: "+this.$route.params.id,"SorteoDetail.vue - created()");
          toastService.warning(res.Message);
        }else{
          logService.Info("Actualización de números terminada - Sorteo: "+this.$route.params.id,"SorteoDetail.vue - created()");
          toastService.success("Actualización de números terminada.");
          eventService.emit("NumerosDisponibles-Refresh", true);
        }
      })
      .catch((err: any) => {
        this.actualizandoNumeros = false;
        logService.Error("Ha habido un problema en la actualización de números - Sorteo: "+this.$route.params.id,"SorteoDetail.vue - created()", null, err);
        toastService.error("Ha habido un problema en la actualización de números.");
      });
    });
  }

  destroyed(){
    eventService.off(this.nameEventCloseActualizarNumeros);
    eventService.off(this.nameEventSaveActualizarNumeros);
  }

  load(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoDetail.vue - load()");
    let self = this;

    this.sorteoService.getById(this.$route.params.id).then((res: any) => {
      self.sorteo = res;
      eventService.emit("SorteoDetailLoaded", this.sorteo);
    })

    this.filtroService.getBySorteo(this.$route.params.id).then((res: Array<Filtro>) => {
      let listRes = new List<Filtro>(res);

      this.filtroSacarNumeros = listRes.FirstOrDefault(x => x !== undefined && x.Ventana === "SacarNumeros");
      this.filtroNumerosDisponibles = listRes.FirstOrDefault(x => x !== undefined && x.Ventana === "NumerosDisponibles");
    })
  }

  onActualizarNumeros(){
    logService.Info("Inicio - Sorteo: "+this.$route.params.id,"SorteoDetail.vue - onActualizarNumeros()");
    this.visibleActualizarNumeros = true;
  }

}
